module.exports = __webpack_public_path__ + "assets/img/portal_process.ff470ce4.png";